import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { PROMOTION_CREDIT_CONSTRAINTS } from './constraints.js';
import { lowercaseUuid } from './lowercase-uuid.js';
const { min, max } = PROMOTION_CREDIT_CONSTRAINTS.reverseIds;
const { label, maxLength } = PROMOTION_CREDIT_CONSTRAINTS.reason;
export const reversePromotionCreditsInputSchema = z.object({
    ids: z
        .array(requiredUuidString('Credit is required.', 'Invalid credit selection.').transform(lowercaseUuid))
        .min(min, 'Select at least one credit to reverse.')
        .max(max, `You can reverse at most ${max} credits at a time.`)
        .refine((ids) => new Set(ids).size === ids.length, {
        message: 'Each credit can be selected only once.',
    }),
    reason: z
        .string({ error: `${label} is required.` })
        .trim()
        .min(1, `${label} is required.`)
        .max(maxLength, `${label} must be ${maxLength} characters or fewer.`),
});
//# sourceMappingURL=reverse-input.js.map